export const AUTH_STORAGE_KEY = 'auth-storage'
export const SEARCH_SECTION_STORAGE_KEY = 'search-section-storage'
export const GROUPED_FILTER_SECTION_STORAGE_KEY = 'grouped-filter-section-storage'
export const COMMAND_PALETTE_RECENTS_STORAGE_KEY = 'command-palette-recents'
